__turbopack_context__.v({
  "logoImage": "StandardSubNavItem-module__2xhdfG__logoImage",
  "logoImgWrapper": "StandardSubNavItem-module__2xhdfG__logoImgWrapper",
  "subNavDesc": "StandardSubNavItem-module__2xhdfG__subNavDesc",
  "subNavItemWrapper": "StandardSubNavItem-module__2xhdfG__subNavItemWrapper",
});
